<template>
  <div>
    <div>
      <div class="main-wrapper">
        <div>
          <!-- <layout-header2></layout-header2> -->
          <layout-header></layout-header>
          <breadcrumb64></breadcrumb64>
          <!-- Page Content -->
          <div class="content">
            <div class="container">
              <div class="row">
                <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                  <sidebar></sidebar>
                </div>
                <div class="col-md-7 col-lg-8 col-xl-9 doctor-profile">
                  <div class="card ml-4" id="shedule_container" style="border: none;">
                    <!-- Page Content -->
                    <div v-for="(module, index) in modules" :key="index">
                      <div class="module" @click="toggleContent(index)">
                        <span>{{ module.title }}</span>
                        <span class="arrow-icon" :class="{ active: activeModule === index }"><i
                            class="fas fa-angle-down"></i></span>
                      </div>
                      <div :class="['module-content', { active: activeModule === index }]">
                        <!-- Check if the video source is YouTube or a local file -->
                        <div v-if="isYouTube(module.videoSrc)">
                          <iframe :src="module.videoSrc" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen style="width: 100%; height: 300px;"></iframe>
                        </div>
                        <div v-else>
                          <video controls>
                            <source :src="module.videoSrc" type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        </div>

                        <div class="btn-group" v-if="module.title !== 'Knee X ray Assessment'">
                          <button @click="handleAssessment('Pre', module)">Pre Training Assessment</button>
                          <button @click="handleAssessment('Post', module)">Post Training Assessment</button>
                        </div>
                      </div>
                    </div>

                  </div>
                  <!-- /Basic Information -->
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
          <layout-footer></layout-footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeModule: null, // Keep track of the currently active module
      modules: [
        {
          title: "Basic of Knee Anatomy",
          videoSrc: "https://www.youtube.com/embed/FmjjgktjArI",
          preUrl: "https://forms.gle/L45nbJv7jdBLCQLJ7",
          postUrl: "https://forms.gle/L45nbJv7jdBLCQLJ7"
        },
        {
          title: "Understanding Knee Osteoarthritis",
          videoSrc: "https://www.youtube.com/embed/ZCu3jKgqnic",
          preUrl: "https://forms.gle/Pmy2jkFhYnbyVKbB9",
          postUrl: "https://forms.gle/Pmy2jkFhYnbyVKbB9"
        },
        {
          title: "Understanding Avascular Necrosis of Femoral head",
          videoSrc: "https://www.youtube.com/embed/0yBjK2G952k",
          preUrl: "https://forms.gle/4eyLbJKNzU8pMB7i8",
          postUrl: "https://forms.gle/4eyLbJKNzU8pMB7i8"
        },
        {
          title: "Knee Deformity Assessment",
          videoSrc: "https://www.youtube.com/embed/7-mrTWO-pA8",
          preUrl: "https://forms.gle/W2Cfczap9RWuuR3v7",
          postUrl: "https://forms.gle/W2Cfczap9RWuuR3v7"
        },
        {
          title: "Understanding Sahaj Therapy",
          videoSrc: "https://www.youtube.com/embed/NKeode3iIjU",
          preUrl: "https://forms.gle/93TyjqGzDGBK1hsv9",
          postUrl: "https://forms.gle/93TyjqGzDGBK1hsv9"
        },
        {
          title: "Patient Selection Criteria for OA & AVN",
          videoSrc: "https://www.youtube.com/embed/puIGIzYJ7oI",
          preUrl: "https://forms.gle/XHcFxCFWU7iNajmF9",
          postUrl: "https://forms.gle/XHcFxCFWU7iNajmF9"
        },
        {
          title: "PRP vs Ad. SVF Sahaj Therapy",
          videoSrc: "https://www.youtube.com/embed/3Ybm7WALA4o",
          preUrl: "https://forms.gle/mETVQ21L3DExZN2VA",
          postUrl: "https://forms.gle/mETVQ21L3DExZN2VA"
        },
        {
          title: "BMAC vs Ad. SVF Sahaj Therapy",
          videoSrc: "https://www.youtube.com/embed/Cqrn5RPiGh8",
          preUrl: "https://forms.gle/zH1BfzVzCnghr3wL8",
          postUrl: "https://forms.gle/zH1BfzVzCnghr3wL8"
        },
        {
          title: "Pain scores & its significance: VAS, KOOS and HOOS",
          videoSrc: "https://www.youtube.com/embed/GEwiso2lDrI",
          preUrl: "https://forms.gle/mp7YjbkDc3kCW35Z7",
          postUrl: "https://forms.gle/mp7YjbkDc3kCW35Z7",
        },
        {
          title: "Knee X ray Assessment",
          videoSrc: "https://www.youtube.com/embed/iIYbw_vKwDM",
        },

      ],
    };
  },
  methods: {
    toggleContent(index) {
      this.activeModule = this.activeModule === index ? null : index;
    },
    handleAssessment(type, module) {
      const url = type === "Pre" ? module.preUrl : module.postUrl;
      window.open(url, "_blank");
    },
    isYouTube(url) {
      return url.includes("youtube.com/embed");
    },
  },
};
</script>

<style scoped>
.container {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

h2 {
  color: #1a3e92;
  display: flex;
  align-items: center;
  font-size: 24px;
  margin-bottom: 20px;
}

.module {
  border-bottom: 1px solid #ddd;
  padding: 15px;
  background-color: #e8e8e8;
  cursor: pointer;
  font-size: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  border-radius: 5px;
}

.module-content {
  display: none;
  padding: 20px;
}

.module-content.active {
  display: block;
}

video {
  width: 100%;
  border-radius: 8px;
  margin-bottom: 10px;
}

.btn-group {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.btn-group button {
  background-color: #66cdaa;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.btn-group button:hover {
  background-color: #14357d;
}

.arrow-icon {
  font-size: 16px;
  transition: transform 0.3s ease;
}

.arrow-icon.active {
  transform: rotate(180deg);
}

@media (max-width: 768px) {
  .container {
    max-width: 100%;
    padding: 10px;
  }

  .btn-group {
    flex-direction: column;
    gap: 10px;
  }

  .btn-group button {
    width: 100%;
    font-size: 14px;
  }

  h2 {
    font-size: 20px;
  }

  .module {
    font-size: 16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/kneexpert/doctor/Training.vue